import React, { useContext, useEffect, useState } from "react";
import "./Blog_Details.css";
import { useNavigate, useParams } from "react-router-dom";
import { getAllBlog, getSingleBlog } from "../../../utils/apis/blog/Homeapi";
import { decodeId, formatViews, timeAgoOrDate } from "../../../utils/common";
import { Context } from "../../../utils/context";

import parse from "html-react-parser";

const Blog_Details = () => {


  const {
    IMG_URL,
    appSetup
  } = useContext(Context);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const recentBlogs = [
    {
      id: 1,
      title: "A Variety of Safe Taxi Services on Your Way",
      image: "/assets/images/home/blog_section/img-1.png",
      date: "1 day",
    },
    {
      id: 2,
      title: "Mountain Adventure Travel Guide",
      image: "/assets/images/home/blog_section/img-2.png",
      date: "2 days",
    },
    {
      id: 3,
      title: "Explore Nature Easily",
      image: "/assets/images/home/blog_section/img-3.png",
      date: "5 days",
    },
    {
      id: 4,
      title: "A Variety of Safe Taxi Services on Your Way",
      image: "/assets/images/home/blog_section/img-1.png",
      date: "1 day",
    },
    {
      id: 5,
      title: "Mountain Adventure Travel Guide",
      image: "/assets/images/home/blog_section/img-2.png",
      date: "2 days",
    },
    {
      id: 6,
      title: "Explore Nature Easily",
      image: "/assets/images/home/blog_section/img-3.png",
      date: "5 days",
    },
  ];


  const { id } = useParams()


  const [blog, setBlog] = useState();
  const getBlogDetails = async () => {
    const res = await getSingleBlog(decodeId(id));

    if (res?.success) {
      setBlog(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }


  const [blogs, setBlogs] = useState();
  const getAllBlogs = async () => {
    const res = await getAllBlog({ id: decodeId(id) });

    if (res?.success) {
      setBlogs(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }


  useEffect(() => {
    getAllBlogs();
    getBlogDetails();
  }, [id]);
  return (
    <section className="Blog_Details">
      <div className="container">
        <h6 className="back" onClick={handleBack}>
          Back
        </h6>
        <div className="blog_details_section">
          <div className="row">
            <div className="col-lg-8 col-md-7">
              <div className="blog_main">
                <h2 className="blog_main_title">
                  {blog?.blog_name || ""}
                </h2>
                <div className="blog_main_image_wrapper">
                  <img
                    src={IMG_URL + blog?.image}
                    // src="/assets/images/home/blog_section/img-1.png"
                    alt="blog"
                    className="blog_main_image"
                  />
                  <div className="blog_image_overlay">
                    <span>{timeAgoOrDate(blog?.createdAt)}</span>
                    <span>Views: {formatViews(blog?.views)}</span>
                  </div>
                </div>

                <div className="blog_description">
                  <p className="blog_text">
                    {parse(blog?.description || "")}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-5">
              <div className="recent_blog_sidebar">
                <h5 className="recent_title">Recent Blogs</h5>
                <div className="recent_blog_list">
                  {blogs?.data?.map((blog) => (
                    <div key={blog.id} className="recent_blog_card">
                      <img
                        src={IMG_URL + blog.image}
                        alt=""
                        className="recent_blog_image"
                      />

                      <div className="recent_blog_overlay">
                        <h6 className="item_title">{blog.blog_name || ""}</h6>

                        <div className="recent_footer">
                          <span>{timeAgoOrDate(blog?.createdAt)}</span>
                          <span className="read_btn">Start Reading</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog_Details;
